import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from 'react-router-dom';
import Footer from '../component/Footer';
import baseURL from '../component/baseURL';
import showNotification from '../component/Notification';
import stringsoflanguages from '../component/stringsoflanguages';

export default function News() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('1');
    const [userID, setUserID] = useState('');
    const [news, setNews] = useState([]);
    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        fetchDetailsAPI('1', userid);
    }, []);

    const handleSelect = (selectedKey) => {
        setActiveTab(selectedKey);
        fetchDetailsAPI(selectedKey, userID);
    };

    const renderNewsCards = (emptyMessage) => (
        <div className="news-content">
            <div className="my-listings-cards-grid">
                <div className={`property-grid ${news.length === 0 ? 'empty-div' : ''}`}>
                    {news.length === 0 ? (
                        <p className="no-data-message">{emptyMessage}</p>
                    ) : (
                        news.map((listing, index) => {
                            const id = listing.listing_id ?? listing.ListingId ?? index;
                            const image = listing.image ?? 'https://placehold.co/600x400';
                            const title = listing.ListingId ?? listing.listing_id ?? '—';
                            const propertyType = listing.PropertyType ?? 'Property Type';
                            const streetPart = [listing.StreetNumber, listing.StreetName].filter(Boolean).join(' ').trim();
                            const cityParts = [listing.city_name, listing.state_name, listing.PostalCode, listing.country_name].filter(Boolean);
                            const cityPart = cityParts.join(', ').trim();
                            const address = streetPart ? (cityPart ? `${streetPart}, ${cityPart}` : streetPart) : (cityPart || '—');
                            const areaValue = listing.LivingArea ?? listing.LotSizeArea ?? null;
                            const rawUnit = listing.LivingAreaUnits ?? listing.LotSizeUnits ?? 'Sq Feet';
                            const areaUnitDisplay = /meter|metre/i.test(String(rawUnit)) ? 'm²' : 'ft²';
                            const area = areaValue != null && areaValue !== '' ? `${areaValue} ${areaUnitDisplay}` : '—';
                            const bedrooms = listing.BedroomsTotal ?? '—';
                            const bathrooms = listing.BathroomsTotalInteger ?? '—';
                            const parking = listing.ParkingTotal ?? listing.GarageSpaces ?? '—';
                            const price = listing.ListPrice ?? '—';
                            const status = (listing.StandardStatus ?? listing.StandardStatusName) || '—';
                            const agentDetails = listing.agent_details ?? {};
                            const agentName = [agentDetails.fname, agentDetails.lname].filter(Boolean).join(' ').trim() || '—';
                            const agentAvatar = agentDetails.picture_thumb ?? agentDetails.picture ?? 'https://placehold.co/40x40';

                            return (
                                <div
                                    key={id}
                                    className="property-card cursor-pointer"
                                    onClick={() => navigate('/portfolio-details', {
                                        state: { listingID: listing.listing_id ?? listing.ListingId ?? id, from: 'news' }
                                    })}
                                >
                                    <div className="property-image">
                                        <img src={image} alt="property" />
                                        <div className="agent-info">
                                            <div className="agent-avatar">
                                                <img src={agentAvatar} alt="agent" />
                                            </div>
                                            <div className="agent-name">
                                                <span>{agentName}</span>
                                            </div>
                                        </div>
                                        <div className="status">
                                            {status === 'Active' && (
                                                <>
                                                    <span className="status-dot active"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Coming Soon' && (
                                                <>
                                                    <span className="status-dot coming-soon"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Sold' && (
                                                <>
                                                    <span className="status-dot sold"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Cancelled' && (
                                                <>
                                                    <span className="status-dot cancelled"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Under Offer' && (
                                                <>
                                                    <span className="status-dot under-offer"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {(!status || !['Active', 'Coming Soon', 'Sold', 'Cancelled', 'Under Offer'].includes(status)) && (
                                                <>
                                                    <span className="status-dot"></span>
                                                    <span>{status || 'N/A'}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="property-content">
                                        <h3 className="property-title">{title} <span className="type ml-4">{propertyType}</span></h3>
                                        <div className="location">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fillOpacity="0.35" />
                                            </svg>
                                            <span>{address}</span>
                                        </div>
                                        <div className="property-details">
                                            <div className="detail-row">
                                                <div className="detail-item">
                                                    <i className="fa-solid fa-ruler-combined"></i>
                                                    <span>{area}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <i className="fa-solid fa-bed"></i>
                                                    <span>{bedrooms}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <i className="fa-solid fa-bath"></i>
                                                    <span>{bathrooms}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <i className="fa-solid fa-car"></i>
                                                    <span>{parking}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="price-type">
                                            <span className="price">{price !== '—' && price !== '' && !isNaN(Number(price)) ? `€ ${Number(price).toLocaleString()}` : price}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );

    const renderContent = () => {
        switch (activeTab) {
            case '1':
                return renderNewsCards(stringsoflanguages.noNewListingsInTheLast24Hours);
            case '2':
                return renderNewsCards(stringsoflanguages.noPriceChangesInTheLast24Hours);
            case '3':
                return renderNewsCards(stringsoflanguages.noSoldListingsInTheLast24Hours);
            default:
                return renderNewsCards(stringsoflanguages.noNewListingsInTheLast24Hours);
        }
    };



    function fetchDetailsAPI(filterValue, userid) {

        let currentUnixTime = Math.floor(Date.now() / 1000)

        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("timestamp", currentUnixTime)
        formdata.append("filter", filterValue)

        console.log('fetchDetailsAPI');
        console.log(formdata);

        fetch(baseURL.URL + '/portfolio/portfolio_news', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response.result
                console.log(result)
                if (responseJson.server.code === 200) {
                    setNews(result);

                }
                else {
                    // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM).
                    showNotification('Error', responseJson.server.message, 'danger');
                    setNews([]);
                }
            })
            .catch((error) => {
                console.error(error);
                setNews([]);
                showNotification('Error', 'Something went wrong while fetching news data', 'danger');
            });
    }

    return (
        <>
            <div className="news-page">
                <div className='container'>
                    {/* Search and Filter Section */}
                    <div className="search-filter-section">
                        <div className="search-bar">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                className="search-icon"
                            >
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="#E1730B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17.5 17.5L13.875 13.875"
                                    stroke="#E1730B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search by name / company"
                                className="search-input"
                            />
                        </div>
                        <button className="filter-btn">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className='nav-content'>
                        <Nav variant="pills" activeKey={activeTab} onSelect={handleSelect}>
                            <Nav.Item className={activeTab === '1' ? 'active' : ''}>
                                <Nav.Link eventKey="1">{stringsoflanguages.new}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className={activeTab === '2' ? 'active' : ''}>
                                <Nav.Link eventKey="2">{stringsoflanguages.priceChange}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className={activeTab === '3' ? 'active' : ''}>
                                <Nav.Link eventKey="3">{stringsoflanguages.sold}</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>

                    {/* Content Area */}
                    <div className="news-content-wrapper">
                        {renderContent()}
                    </div>
                </div>
                {/* <Footer /> */}
            </div>

        </>
    );
}